(function(){

    angular.module('tmx-app').controller('regionLevelReportCtrl', ['$scope','$state','$mdDialog', 'tmxUtility','$mdSidenav',
        'TmxDialogService','ServerExceptionService','resolvedData',RegionLevelReportCtrl]);

    function RegionLevelReportCtrl($scope, $state,$mdDialog,tmxUtility,$mdSidenav, TmxDialogService,ServerExceptionService,resolvedData){
        var regionLevelReportVM=this;
        regionLevelReportVM.loading=false;
        regionLevelReportVM.TimeFrames = resolvedData.TimeFrames.data;
    }

})();